import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/productsapp`;
const token = localStorage.getItem("token");

/// GET
// Fonction pour récupérer tous les produits-Applications
export const getAllProductsApp = async () => {
  try {
    const response = await axios.get(`${apiUrl}/allproductsapp`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des produits:", error);
    return [];
  }
};

// Fonction pour récupérer un produit-Application par son id
export const getProductAppById = async (productId) => {
  try {
    const response = await axios.get(`${apiUrl}/productById/${productId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération du produit:", error);
    return null;
  }
};

/// POST
// Fonction pour ajouter un produit-Application
export const addProductApp = async (product) => {
  try {
    const response = await axios.post(`${apiUrl}/addProductApp`, product, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout du produit:", error);
    return null;
  }
};

/// PATCH
// Fonction pour mettre à jour un produit-Application
export const updateProductApp = async (id, productData) => {
  try {
    const response = await axios.patch(
      `${apiUrl}/updateProductApp/${id}`, // L'ID est bien utilisé ici
      productData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour du produit:", error);
    return null;
  }
};

/// DELETE
// Fonction pour supprimer un produit-Application
export const deleteProductApp = async (id) => {
  try {
    const response = await axios.delete(`${apiUrl}/deleteProductApp/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression du produit:", error);
    return null;
  }
};
